import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {

  // Portal APIs:-

  // Login Page
  loginUrl: string = 'api/PortalDoctors/portal-login';
  logoutUrl: string = 'api/PortalDoctors/Logout';
  forgetPasswordUrl: string = 'api/PortalDoctors/ForgetPassword';
  verifyForgetPasswordOtpUrl: string = 'api/PortalDoctors/VerifyForgetPasswordOtp';
  resetForgottenPasswordUrl: string = 'api/PortalDoctors/ResetForgottenPassword';
  refreshTokenUrl: string = 'api/PortalDoctors/RefreshToken';
  getMedicationStockDetailsUrl: string = 'api/MedicationStock/details';
  getMedicationAvailableStocksUrl: string = 'api/MedicationStock/available-stocks';
  removeMedicationEXPStockUrl: string = 'api/MedicationStock';
  loginOtpRequestUrl: string = 'api/PortalDoctors/portal-login/otp/request';
  loginOtpVerifyUrl: string = 'api/PortalDoctors/portal-login/otp/verify';

  // Home Page
  checkUserLoginUrl: string = 'api/PortalTests/GetTests/2';
  connectToPatientUrl: string = 'api/PortalDoctors/ConnectToPatient';
  connectToConvoyPatientUrl: string = 'api/PortalConvoyDoctors/ConnectToConvoyPatient';
  requestViewEMRUrl: string = 'api/EMR/RequestViewEMR';
  verifyViewEMROTPUrl: string = 'api/EMR/VerifyViewEMROTP';
  doctorComplaintUrl: string = 'api/PortalDoctors/GetDoctorComplaintEmails'

  // E-Prescription Page
  getAllDiagnosesUrl: string = 'api/PatientDiagnoses/GetAllDiagnoses';
  // getAllMedicationsUrl: string = 'api/Medications/GetAllMedications';
  getTestsUrl: string = 'api/PortalTests/GetTests';
  addPrescriptionUrl: string = 'api/PortalPrescriptions/V2/AddPrescription';
  getTopMedicationsByDoctorIdUrl: string = 'api/Medications/GetTopMedicationsByDoctorId';

  // EMR Details Page
  getPatientEmrDetailsUrl: string = 'api/emr/GetPatientEmrDetails';

  // EMR Medical Tests Page
  getPatientTestRequestsUrl: string = 'api/PortalTestRequests/GetPatientTestRequests';

  // Medical Test Details Page
  getTestRequestDetailsUrl: string = 'api/PortalTestRequests/GetTestRequestDetails';

  // EMR Medications Page
  getPatientEhrPrescriptionsUrl: string = 'api/PortalEhr/GetPatientEhrPrescriptions';

  // EMR Hospital Procedure Page
  getPatientEhrHospitalProceduresUrl: string = 'api/PortalEhr/GetPatientHospitalProcedures';

  // EMR Hospital Procedure Details Page
  getPatientEhrHospitalprocedureFilesUrl: string = 'api/PortalEhr/GetPatientEhrUploadedFiles';

  // EMR Prescription Details Page
  getPatientEhrPrescriptionDetailsUrl: string = 'api/PortalEhr/GetPatientEhrPrescriptionDetails';
  getPatientEhrPrescriptionFilesUrl: string = 'api/PortalEhr/GetPatientEhrUploadedFiles';
  getPatientEhrDetailsUrl: string = 'api/PortalEhr/GetPatientEhrTransactions';

  getPatientRecentMedicalTestsUrl: string = 'api/PortalEhrMedicalTests/GetAllPatientRecentMedicalTests';
  getPatientCompletedMedicalTestsUrl: string = 'api/PortalEhrMedicalTests/GetAllPatientCompletedMedicalTests';

  getMedicalTestDetailsUrl: string = 'api/PortalEhrTestRequests/GetTestRequestDetails';
  getMedicalTestFileDetailsUrl: string = 'api/PortalEhrTestResultsFiles/GetMedicalTestResultFilesByAdminByEhrTransactionId';

  getPatientAllVitalsDataUrl: string = 'api/PortalEhr/GetPatientVitlas';
  //Top Used Medical Services
  getTopUsedMedicalServiceUrl: string = 'api/PortalMedicalServices/GetTopUsedMedicalServicesByDoctorId';
  constructor() { }

  //GetAppVersion
  getAppVersionUrl: string = 'api/AppsVersions/PatientAppVersions';

  getDrugIndexBySearchUrl: string = 'api/DrugIndexes/Search';
  getMedicinesByIdUrl: string = 'api/DrugIndexes/GetMedicinesById';
  getPatientsBySearchUrl: string = 'api/Patients/Search?nameOrPhone=';
  getTestsBySearchUrl: string = 'api/PortalTests/Search';
  getDiagnosesBySearchUrl: string = 'api/PatientDiagnoses/Search';
  getHivDiagnosisUrl: string = 'api/PatientDiagnoses/hiv-diagnosis';
  getHivDiagnosisV2Url: string = 'api/PatientDiagnoses/v2/hiv-diagnosis?patientId=';
  getTreatmentsUrl: string = 'api/TreatmentLine';
  getMedicinesForTreatmentLineUrl: string = 'api/TreatmentLine/medicines';
  getAnalyticsUrl: string = 'api/PortalPatientEhr/analytics';

  // Site Management
  clinicsByDoctorUrl: string = 'api/sitemanagement/clinics/by-doctor';
  createClinicUrl: string = 'api/sitemanagement/clinics';
  updateClinicUrl: string = 'api/sitemanagement/clinics/{clinicId}';
  doctorServicesUrl: string = 'api/SiteServiceDefinition/doctor';
  paymentMethodsUrl: string = 'api/PaymentGateway';
  SiteServiceSearchUrl: string = 'api/SiteService/search';

  checkPatientHasBirthdateUrl: string = 'api/PortalPatients/CheckPatientHasBirthdate';
  checkPatientConsentsByBirthdateUrl: string = 'api/PortalPatients/CheckPatientConsentsByBirthdate';
  checkPatientConsentsByOTPUrl: string = 'api/PortalPatients/CheckPatientConsentsByOTP';
  sendToPatientOTPUrl: string = 'api/PortalPatients/SendToPatientOTP';
  getPatientEhrTransactionsLastReadingsUrl: string = 'api/PortalEhr/GetPatientEhrTransactionsLastReadings?patientId=';

  //Esomeprazole
  getEsomeprazolePatientUrl: string = 'api/EsomeprazolePatients/GetOrSetEsomeprazolePatient';
  addFirstVisitEsmoprazoleUrl: string = 'api/EsomeprazolePatients/SaveFirstVisitData';
  addSecondVisitEsmoprazoleUrl: string = 'api/EsomeprazolePatients/SaveFollowUpVisitData';
  getPatientVisitsDataUrl: string = 'api/EsomeprazolePatients/patientData/';

  //Doctor subscription
  postDoctorSubscriptionDataUrl: string = 'api/PortalDoctors/subscriptionRequests';

  //Configurations
  getConfigurationsUrl: string = 'api/Configuration/GetConfigurations';

  //HIV clinic model
  hivRegistrationUrl: string = 'api/HIVPatients/register';
  hivRegistrationDataUrl: string = 'api/HIVPatients/registration-data';
  hivInfectionWaysUrl: string = 'api/HIVPatients/infection-ways';
  hivExaminationReasonsUrl: string = 'api/HIVPatients/examination-reasons';
  isHIVPatientRegisteredUrl: string = 'api/PortalPatients/isRegisteredPatient';
  getAllHivMedicinesUrl: string = 'api/DrugIndexes/hiv-medicines';

  // Hospitals
  getAllHIVHospitalsUrl: string = 'api/hospitals/hiv';
  getAllHospitalPatients: string = 'api/hospitals/patients';

  // Medication Orders Module
  patientsLookupUrl: string = 'api/PortalDoctors/patients-lookup';
  getMedicationOrdersUrl: string = 'api/MedicationOrders';
  addMedicationOrderUrl: string = 'api/MedicationOrders';
  getOrdersHistoryUrl: string = 'api/MedicationOrders/orders-history';
  getOrderHistoryDetailsUrl: string = 'api/MedicationOrders/orders-history-details';
  getOrderCancellationReasonsUrl: string = 'api/MedicationOrders/cancellation-reasons';
  cancelMedicationOrderUrl: string = 'api/MedicationOrders/cancel';

  // Medication Stocks
  getMedicationsStocksUrl: string = 'api/MedicationStock';
  getMedicationAvailableQuantityUrl: string = 'api/MedicationStock/available-quantity';
  addMedicationStockUrl: string = 'api/MedicationStock';
  getActiveBatchesUrl: string = 'api/MedicationStock/active-batches';

  getPatientDataToCreateRXUrl: string = 'api/PortalPatients/GetPatientDataToCreateRX';

  // patient case images
  getAllAnatomyUrl: string = 'api/Anatomy';
  uploadCaseImageUrl: string = 'api/PatientCase/upload-images';
  addPatientCaseUrl: string = 'api/PatientCase/add';
  getPatientCasesUrl: string = 'api/PatientCase';
  doesPatientHaveCases: string = 'api/PatientCase/DoesPatientHaveCases';


  // New EHR 
  getEHRStatisticsUrl: string = 'api/PortalPatientEhr/statistics/';
  getVitalsGraphsUrl: string = 'api/PortalPatientEhr/vitals/graph?patientId=';
  getAllVitalsUrl: string = 'api/PortalPatientEhr/vitals';
  getAllLabtestsUrl: string = 'api/PortalPatientEhr/tests/labs?patientId=';
  getAllRadiologiesUrl: string = 'api/PortalPatientEhr/tests/scans?patientId=';
  getAllPhysiotherapiesUrl: string = 'api/PortalPatientEhr/tests/physiotherapy?patientId=';
  getAllMedicationsUrl: string = 'api/PortalPatientEhr/medications?patientId=';
  getAllSiteServicesUrl: string = 'api/PortalPatientEhr/site-services?patientId=';
  getAllCaseimagesUrl: string = 'api/PortalPatientEhr/case-images?patientId=';
  getPrescriptionsAvailabilityUrl: string = 'api/PortalPatientEhr/data-availability?patientId=';


  // HIV
  getPendingPrescriptionsUrl: string = 'api/PortalPrescriptions/pending';
  getPortalPrescriptionsUrl: string = 'api/PortalPrescriptions';
  getPrescriptionByIdUrl: string = 'api/PortalPrescriptions';
  editPrescriptionUrl: string = 'api/PortalPrescriptions/edit';
  getCountriesUrl: string = 'api/Countries/lookup';
  // Stock Transfer
  CreateStockTransferRequestUrl: string = 'api/StockTransfer/StockTransfer';
  GetStockTrasferTransactionsUrl: string = 'api/StockTransfer/GetTransactionsHistory';
  CancelStockTransferRequestUrl: string = 'api/StockTransfer/CancelStocktransfer';
  AcceptStockTransferRequestUrl: string = 'api/StockTransfer/AcceptStocktransfer';
  RejectStockTransferRequestUrl: string = 'api/StockTransfer/RejectStocktransfer';
  TransactionStatusLookupUrl: string = 'api/StockTansactionstatuses/GetTansactionsHistory';
  RejectionReasonLookupUrl: string = 'api/StockTransactionRejectionReason/GetStockTransactionRejectionReason';
  ExportStockTransferUrl: string = 'api/StockTransfer/GetTransactionsHistoryExcel';

  // Patient Transfer
  GetTransferReasonLookups: string = 'api/PatientTransfer/reasons';
  GetSentPatients: string = 'api/PatientTransfer/transferred';
  GetReceivedPatients: string = 'api/PatientTransfer/received';
  CreatePatientTransferRequest: string = 'api/PatientTransfer';
  GetSentPatientsExcel: string = 'api/PatientTransfer/transferred-excel'
  GetReceivedPatientsExcel: string = 'api/PatientTransfer/received-excel'

  // PEP
  isPEPatientRegisteredUrl: string = 'api/pep/patient-enrollment-status';
  getPepPatientsListUrl: string = 'api/pep/patients';

  // Patient Documents
  uploadPatientDocumentUrl: string = 'api/PatientDocuments/upload';
  getUploadedDocumentsUrl: string = 'api/PatientDocuments';

  // Clinic Analysis
  getClinicOrdersUrl: string = 'api/SiteAnalysis/clinic-orders';

  // PSP
  getAllPspProgramsByCompanyId: string = 'api/AdminPspPrograms/GetAllProgramsByCompanyId';
  getLoggedInRocheDoctorTypes: string = 'api/RocheDoctors/get-roche-doctor-types';
  getProgramMedicine: string = 'api/PspPrograms/program-medicines';
  createDoctorPortalRochePspSubscription: string = 'api/PspSubscriptions/roche-enrollment';
  getAllCompanyProgramMedicines: string = 'api/PspPrograms/company-program-medicines';
  getAllPspMedicines: string = 'api/PspPrograms/GetAllPSPMedicines';
  getTopUsedRochePrograms: string = 'api/PspPrograms/top-used/roche'
}
